import { render, staticRenderFns } from "./project-config-form.vue?vue&type=template&id=606f8ecb&scoped=true"
import script from "./project-config-form.vue?vue&type=script&setup=true&lang=js"
export * from "./project-config-form.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606f8ecb",
  null
  
)

export default component.exports